export enum SituacaoSolicitacaoEnum {
    CADASTRADO = 'CADASTRADO',
    SOLICITADO = 'SOLICITADO',
    APROVADO = 'APROVADO',
    REPROVADO = 'REPROVADO',
    EM_EXIGENCIA = 'EM_EXIGENCIA',
    NAO_SOLICITADO = 'NAO_SOLICITADO',
    SUSPENSO = 'SUSPENSO',
    CANCELADO = 'CANCELADO'
}

export class SituacaoSolicitacaoSgsia{

    static descricaoSituacao(situacaoSolicitacao: SituacaoSolicitacaoEnum): string {
        switch (situacaoSolicitacao){
            case SituacaoSolicitacaoEnum.CADASTRADO:
                return 'Cadastrado';
            case SituacaoSolicitacaoEnum.SOLICITADO:
                return 'Solicitado';
            case SituacaoSolicitacaoEnum.APROVADO:
                return 'Aprovado';
            case SituacaoSolicitacaoEnum.REPROVADO:
                return 'Reprovado';
            case SituacaoSolicitacaoEnum.EM_EXIGENCIA:
                return 'Em exigência';
            case SituacaoSolicitacaoEnum.NAO_SOLICITADO:
                return 'Não solicitado';
            case SituacaoSolicitacaoEnum.SUSPENSO:
                return 'Suspenso';
            case SituacaoSolicitacaoEnum.CANCELADO:
                return 'Cancelado';
            default: situacaoSolicitacao;
        }
    }

}
